import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  IconButton,
} from "@mui/material";
import React from "react";

export interface UnsavedFeedbackModalProps {
  open: boolean;
  onClose: () => void;
  onLeave: () => void;
}

export const UnsavedFeedbackModal: React.FC<UnsavedFeedbackModalProps> = ({
  open,
  onClose,
  onLeave,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="unsaved-feedback-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="unsaved-feedback-title">
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" component="span" fontWeight="bold">
            Unsaved Changes
          </Typography>
          <IconButton aria-label="close" onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" sx={{ mb: 1 }}>
          You have unsaved feedback.
        </Typography>
        <Typography variant="body1">
          Are you sure you want to leave this page? Your changes will be lost.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onLeave} variant="outlined" color="inherit">
          Leave without saving
        </Button>
        <Button onClick={onClose} variant="contained" color="primary">
          Stay on this page
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedFeedbackModal;
